<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Downline</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div
                class="section curved-header pt-1"
                style="--height-curved: 100px"
            >
                <div class="wallet-card">
                    <div class="balance">
                        <div class="col-6 text-left">
                            <span class="title">Total Downline</span>
                            <h1 class="total">
                                <span>{{
                                    downline_summary.total | rupiah
                                }}</span>
                            </h1>
                        </div>
                        <div class="col-6 text-left">
                            <span class="title">Downline Aktif</span>
                            <h1 class="total">
                                <span>{{
                                    downline_summary.aktif | rupiah
                                }}</span>
                            </h1>
                        </div>
                    </div>
                    <div class="wallet-footer">
                        <button
                            class="btn btn-primary btn-block"
                            @click="actionSheet('show')"
                        >
                            <ion-icon name="add-circle"></ion-icon> Tambah
                            Downline
                        </button>
                    </div>
                </div>
            </div>
            <div class="section full" style="margin-top: 50px">
                <div v-if="downline.data.length > 0">
                    <ul class="listview image-listview-product inset">
                        <li v-for="item in downline.data" :key="item.id">
                            <router-link
                                :to="{
                                    name: 'referral.downline.detail',
                                    params: { id: item.id },
                                }"
                                class="item pl-3 pr-3"
                            >
                                <div class="in">
                                    <div style="width: 90%">
                                        <div>
                                            <h4 style="display: inline">
                                                {{ item.name }}
                                            </h4>
                                            <img
                                                :src="
                                                    require('@/assets/verified.png')
                                                "
                                                alt="image"
                                                class="image"
                                                style="width: 25px"
                                                v-if="
                                                    item.account_verified_approved !=
                                                    null
                                                "
                                            />
                                        </div>
                                        <footer style="line-height: 18px">
                                            Bergabung pada<br />
                                            <b>{{
                                                dateMutation(item.created_at)
                                            }}</b>
                                        </footer>
                                    </div>
                                    <span class="text-muted text-right">
                                        <div>
                                            <b
                                                >Rp
                                                {{ item.balance | rupiah }}</b
                                            >
                                        </div>
                                        <div class="mt-1">
                                            <div
                                                class="badge badge-success-custom badge-outline"
                                                style="padding: 8px 10px"
                                                v-if="item.status == 'ACTIVE'"
                                            >
                                                <b>Aktif</b>
                                            </div>
                                            <div
                                                class="badge badge-danger-custom badge-outline"
                                                style="padding: 8px 10px"
                                                v-else-if="
                                                    item.status == 'INACTIVE'
                                                "
                                            >
                                                <b>Belum Aktif</b>
                                            </div>
                                            <div
                                                class="badge badge-grey-custom badge-outline"
                                                style="padding: 8px 10px"
                                                v-else-if="
                                                    item.status == 'DORMAN'
                                                "
                                            >
                                                <b>Dorman</b>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                                <div class="ml-2 right">
                                    <div class="icon" style="color: #a9abad">
                                        <ion-icon
                                            name="chevron-forward-outline"
                                        ></ion-icon>
                                    </div>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                    <div class="m-2 text-center" v-if="downline.next_page_url">
                        <ButtonLoader
                            :loading="loadingButton"
                            :styled="'btn btn-primary rounded mr-1 mb-1'"
                            @click.native="
                                paginateDownline(downline.next_page_url)
                            "
                            >Lihat lebih banyak</ButtonLoader
                        >
                    </div>
                </div>
                <div class="text-center" style="margin-top: 50px" v-else>
                    <img
                        :src="require('@/assets/image/empty.webp')"
                        alt="404"
                        class="w-75 mb-3"
                    /><br />
                    <i>Data belum tersedia</i>
                </div>
            </div>
        </div>
        <action-sheet
            ref="add_downline"
            :title="'Tambah Downline'"
            :inset="true"
        >
            <div class="form-group boxed">
                <label class="label">Nama</label>
                <input
                    type="text"
                    class="form-control form-control-sm text-capitalize"
                    v-model="downline_data.name"
                    maxlength="25"
                />
                <small><i>Maks. 20 Karakter</i></small>
            </div>
            <div class="form-group boxed">
                <label class="label">No. Handphone (WhatsApp)</label>
                <input
                    type="number"
                    class="form-control form-control-sm"
                    v-model="downline_data.phone"
                    maxlength="13"
                />
                <small><i>Min. 10 digit & Maks. 13 digit</i></small>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-6">
                        <button
                            class="btn btn-secondary btn-block"
                            @click="actionSheet('hide')"
                        >
                            Batal
                        </button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader
                            :loading="loadingButton"
                            :styled="'btn btn-primary btn-block'"
                            @click.native="storeDownline()"
                            >Simpan</ButtonLoader
                        >
                    </div>
                </div>
            </div>
        </action-sheet>
    </div>
</template>
<script>
    import $axios from './../../api.js';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    export default {
        data() {
            return {
                affiliate_id: '',
                loadingApp: true,
                loadingButton: false,
                downline: {
                    data: [],
                },
                downline_summary: {
                    total: 0,
                    aktif: 0,
                },
                downline_total: '0',
                downline_data: {
                    name: '',
                    phone: '',
                },
            };
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
        },
        methods: {
            ...mapActions(['getCustomer', 'getSetting']),
            getdownlineSummary() {
                $axios.get('/referral/downline/summary').then(response => {
                    console.log(response.data.data);
                    this.downline_summary.total = response.data.data.total;
                    this.downline_summary.aktif = response.data.data.aktif;
                });
            },
            paginateDownline(url = '') {
                this.loadingButton = true;
                $axios
                    .get(url ? url : '/referral/downline')
                    .then(response => {
                        if (!this.downline.data) {
                            this.downline = response.data.data;
                        } else {
                            this.downline.data.push(...response.data.data.data);
                            this.downline.next_page_url =
                                response.data.data.next_page_url;
                        }
                        this.loadingButton = false;
                        this.loadingApp = false;
                    })
                    .catch(() => {
                        this.loadingButton = false;
                        this.loadingApp = false;
                    });
            },
            actionSheet(value) {
                let element = this.$refs.add_downline.$el;
                window.$(element).modal(value);
            },
            storeDownline() {
                this.loadingButton = true;
                $axios
                    .post('/referral/downline/create', this.downline_data)
                    .then(response => {
                        (this.downline = {
                            data: [],
                        }),
                            this.paginateDownline();
                        this.actionSheet('hide');
                        this.loadingButton = false;
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: response.data.message,
                            tipe: 'default',
                            icon: 'success',
                        });
                    })
                    .catch(error => {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.response.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                        this.actionSheet('hide');
                        this.loadingButton = false;
                    });
                this.downline_data = {
                    name: '',
                    phone: '',
                };
            },
            dateMutation(date) {
                return moment(date).format('D MMM YYYY H:mm:ss');
            },
        },
        mounted() {
            this.getdownlineSummary();
            this.paginateDownline();
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
